import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatList: [],
  chatDetail: [],
  chatMessagesList: [],
  error: undefined,
  loading: false,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchChatItem(state, action) {
      state.chatList = action.payload;
      state.loading = false;
    },
    fetchChatDetail(state, action) {
      state.chatDetail = action.payload;
      state.loading = false;
    },
    fetchChatMessagesList(state, action) {
      state.chatMessagesList = action.payload;
      state.loading = false;
    },
  },
});

export const chatActions = chatSlice.actions;

export default chatSlice.reducer;
